export const DELIVERY_BAR_TREESHOLD = 1500;
